<template>
  <div class="container">
    <div class="container" v-if="dataReady">
      <div class="examHeader">
        <div class="question-title">
          <van-icon name="clock-o" />
          <van-count-down ref="countdown" :time="maxtime" @finish="timeOut"/>
        </div>
        <div :class="multi ? 'question-content van-multi-ellipsis--l3' : 'question-content'" ref="contentWrapper">第{{currentIndex + 1}}题：{{currentQuestion.questionname}}</div>
        <p class="showall" v-if="showAll">
          <a href="javascript:;" @click="toggleShow">{{multi ? '展开' : '收起'}}</a>
        </p>
      </div>
      <div class="examBody">
        <van-tabs v-model="active">
          <van-tab title="答案选项">
            <div
              class="option-list van-hairline--surround"
              v-for="option in currentQuestion.questionSelectorList"
              :key="option.id"
              :class="{selected: answerSheet[currentIndex].answerselector.indexOf(option.selectorname) > -1}"
              @click="selectAnswer(option.selectorname, currentQuestion.id, currentQuestion.questiontype)"
            >
              <div
                class="van-hairline--surround"
                :class="{'option-checkbox': currentQuestion.questiontype, 'option-radio': !currentQuestion.questiontype}"
              >
                {{option.selectorname}}
              </div>
              <div class="option-content">{{option.content}}</div>
            </div>
            <div class="answer-navigator">
              <div class="answer-navigator__button van-hairline--surround" :class="{disabled: currentIndex === 0 }" @click="prev()">上一题</div>
              <div v-if="currentIndex !== answerSheet.length - 1" class="answer-navigator__button van-hairline--surround" :class="{disabled: currentIndex === questions.length-1}" @click="next()">下一题</div>
              <div v-if="currentIndex === answerSheet.length - 1" class="answer-navigator__button finish_button van-hairline--surround" @click="submitAnswer()">完成答题</div>
            </div>
          </van-tab>
          <van-tab title="答题卡">
            <div class="answer-card">
              <div
                class="answer-card-list"
                v-for="(item, index) in answerSheet"
                :key="item.id"
              >
                <div
                  class="answer-ball van-hairline--surround"
                  :class="{current: currentIndex === index, done: item.answerselector}"
                  @click="selectIndex(index)"
                >{{index + 1}}</div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import $ from 'jquery'
  const u = navigator.userAgent
  export default {
    name: 'examList',
    data () {
      return {
        maxtime: 0,
        active: 0,
        questions: [],
        answerSheet: [],
        currentIndex: 0,
        dataReady: false,
        showAll: false,
        multi: false
      }
    },
    computed: {
      currentQuestion: function() {
        // console.log(this.questions[this.currentIndex])
        return this.questions[this.currentIndex]
      }
    },
    watch: {
      currentQuestion: function() {
        this.$nextTick(function(){
          if ($(this.$refs.contentWrapper).height() > 78) {
            this.showAll = true
            this.multi = true
          } else {
            this.showAll = false
            this.multi = false
          }
        })
      }
    },
    created () {
      this.$toast.allowMultiple()
      this.$fetch.get(API.EXAMQUESTIONLIST, {
        examid: this.$route.query.id
      }).then(response => {
        // console.log(response)
        this.questions = response.data.examQuestionList
        this.maxtime = response.data.maxminute * 60 * 1000
        this.dataReady = true
        var _this = this
        this.questions.forEach(function(item){
          _this.answerSheet.push({
            id: item.id,
            answerselector: ''
          })
        })
      }).catch(error => {
        console.log(error)
      })
    },
    mounted () {
      document.title = this.$store.state.title
    },
    methods: {
      selectAnswer (value, id, multi) {
        if (multi) {
          for (let answer of this.answerSheet) {
            if (answer.id === id) {
              let answerselector = answer.answerselector.length > 0 ? answer.answerselector.split(',') : []
              if (answer.answerselector.indexOf(value) > -1) {
                answerselector.forEach((item, index) => {
                  if (item === value) answerselector.splice(index, 1)
                })
              } else {
                answerselector.push(value)
              }
              this.$set(answer, 'answerselector', answerselector.join(','))
            }
          }
        } else {
          for (let answer of this.answerSheet) {
            if (answer.id === id) {
              this.$set(answer, 'answerselector', value)
            }
          }
          if (this.answerSheet[this.currentIndex+1] && this.answerSheet[this.currentIndex+1].answerselector === '') {
            setTimeout(() => {
              this.currentIndex = this.currentIndex + 1
            }, 200)
          }
        }
      },
      submitAnswer () {
        var _this = this
        for (let answer of this.answerSheet) {
          if (!answer.answerselector) {
            this.$toast.fail('请先完成所有答题再提交！')
            return
          }
        }

        var day = this.$refs.countdown.timeData.days
        var hours = this.$refs.countdown.timeData.hours
        var minutes = this.$refs.countdown.timeData.minutes
        var seconds = this.$refs.countdown.timeData.seconds
        var milliseconds = this.$refs.countdown.timeData.milliseconds

        var residue = (day * 24 * 60 * 60 *1000) + (hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + (seconds * 1000) + milliseconds
        var useTime = this.maxtime - residue

        if (this.$store.state.token) {
          _this.postAnswer(useTime)
        } else {
          let examdata = {
            examid: this.$route.query.id,
            examjson: JSON.stringify(this.answerSheet),
            examtime: useTime
          }
          this.$store.commit('saveexam', examdata)
          if (u.indexOf('MicroMessenger') > -1) {
            var hrefF = process.env.VUE_APP_CURRENTMODE === 'test' ? '/h5/#' : '/#'
            this.$fetch.post(API.GETWECHATAUTHURI, {
              url: window.location.origin + hrefF + '/exam/result?auto=submit'
            })
              .then(response => {
                // console.log(response)
                if (response.status === 200) {
                  window.location.href = response.data.uri
                } else {
                  // console.log(response.message)
                }
              })
          } else {
            // this.$toast.fail('请使用微信端进行答题')
            // return
            this.$dialog.alert({
              message: '请先前往登录再提交答卷'
            }).then(() => {
              this.$router.push({
                path: '/login',
                query: {
                  type: 'exam'
                }
              })
            })
          }
        }
      },
      timeOut () {
        if (this.$store.state.token) {
          this.$toast({
            message: '考试时间已结束，系统将会为您自动提交！',
            forbidClick: true,
            overlay: true,
            duration: 3000
          })
          var _this = this
          setTimeout(function(){
            _this.postAnswer(_this.maxtime)
          }, 3000)
        } else {
          this.$dialog.alert({
            message: '考试时间已结束，请授权登录并提交答卷'
          }).then(() => {
            let examdata = {
              examid: this.$route.query.id,
              examjson: JSON.stringify(this.answerSheet),
              examtime: this.maxtime
            }
            this.$store.commit('saveexam', examdata)
            if (u.indexOf('MicroMessenger') > -1) {
              var hrefF = process.env.VUE_APP_CURRENTMODE === 'test' ? '/h5/#' : '/#'
              this.$fetch.post(API.GETWECHATAUTHURI, {
                url: window.location.origin + hrefF + '/exam/result?auto=submit'
              })
                .then(response => {
                  // console.log(response)
                  if (response.status === 200) {
                    window.location.href = response.data.uri
                  } else {
                    // console.log(response.message)
                  }
                })
            } else {
              this.$router.push({
                path: '/login',
                query: {
                  type: 'exam'
                }
              })
            }
          });
        }
      },
      postAnswer (time) {
        var _this = this
        const load = this.$toast({
          type: 'loading',
          duration: 0,
          loadingType: 'spinner',
          forbidClick: true
        })
        this.$fetch.post(API.EXAMANSWER, {
          examid: this.$route.query.id,
          examjson: JSON.stringify(this.answerSheet),
          answertime: Math.round(time/1000)
        }).then(response => {
          // console.log(response)
          if (response.status !== 200) {
            this.$toast.fail(response.message)
            return
          }
          load.clear()
          this.$toast.success({
            message: '提交成功!',
            forbidClick: true
          })
          setTimeout(function(){
            _this.$router.replace({
              path: '/exam/result',
              query: {
                id: _this.$route.query.id
              }
            })
          }, 2000)
        }).catch(error => {
          load.clear()
          let msg = error.message ? error.message : '提交失败，请稍后尝试!'
          this.$toast.fail(msg)
          console.log(error)
        })
      },
      selectIndex (index) {
        this.currentIndex = index
        this.active = 0
      },
      next() {
        if (this.currentIndex === this.questions.length-1) return
        this.currentIndex = this.currentIndex + 1
      },
      prev() {
        if (this.currentIndex === 0) return
        this.currentIndex = this.currentIndex -1
      },
      toggleShow () {
        this.multi = !this.multi
      }
    },
    beforeRouteLeave (to, from, next) {
      this.$dialog.close()
      next()
    }
  }
</script>

<style lang="stylus">
  
</style>